import * as R from 'remeda';
import { AnnotationStatus } from '@rossum/api-client/shared';
import { disallowedStatuses } from './statuses';

type ExcludedStatuses = (typeof disallowedStatuses)[number];

type SupportedStatus = Exclude<AnnotationStatus, ExcludedStatuses>;

export const isStatusVisible = (s: AnnotationStatus): s is SupportedStatus =>
  !R.isIncludedIn(s, disallowedStatuses);
